"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsTableHead = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productPriceInfo = require("../productColumn/productPriceInfo");
var _productHelpers = require("../../helpers/productHelpers");
var _tableContext = require("./stateHelpers/tableContext");
var _tableHelpers = require("../../helpers/tableHelpers");
var _defaults = require("./defaults");
var _quoteHelpers = require("../../helpers/quoteHelpers");
var _staffProductSummary = require("../staffMode/staffProductSummary");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable react/forbid-prop-types, react/no-array-index-key */
var ProductsTableHead = exports.ProductsTableHead = function ProductsTableHead(_ref) {
  var contentToggleable = _ref.contentToggleable,
    validationErrors = _ref.validationErrors,
    _ref$plans = _ref.plans,
    plans = _ref$plans === void 0 ? {} : _ref$plans,
    onPlanSelect = _ref.onPlanSelect,
    _ref$onActiveProductG = _ref.onActiveProductGroupChange,
    onActiveProductGroupChange = _ref$onActiveProductG === void 0 ? function () {} : _ref$onActiveProductG,
    _ref$onTogglePlanVisi = _ref.onTogglePlanVisibility,
    onTogglePlanVisibility = _ref$onTogglePlanVisi === void 0 ? function () {} : _ref$onTogglePlanVisi,
    _ref$plansVisible = _ref.plansVisible,
    plansVisible = _ref$plansVisible === void 0 ? false : _ref$plansVisible,
    planKey = _ref.planKey;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    brand = _useContext$tableCont.brand,
    groupedProductNames = _useContext$tableCont.groupedProductNames,
    showProductGroupControls = _useContext$tableCont.showProductGroupControls,
    speciesFilter = _useContext$tableCont.speciesFilter,
    ProductGroupingsBySpecies = _useContext$tableCont.ProductGroupingsBySpecies,
    ProductGroupsKeyedByPlanNumber = _useContext$tableCont.ProductGroupsKeyedByPlanNumber,
    _useContext$tableStat = _useContext.tableState,
    dataIsUpdating = _useContext$tableStat.dataIsUpdating,
    activeProductGroup = _useContext$tableStat.activeProductGroup,
    productsAreMerged = _useContext$tableStat.productsAreMerged,
    productQuotes = _useContext$tableStat.productQuotes,
    selectedProduct = _useContext$tableStat.selectedProduct,
    staffMode = _useContext$tableStat.staffMode,
    mobileMode = _useContext$tableStat.mobileSettings.mobileMode;
  var _ref2 = _defaults.DefaultProductTablePriceInfo[brand] || _defaults.DefaultProductTablePriceInfo["default"],
    title = _ref2.title;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasProductGroupControls = _useState2[0],
    setHasProductGroupControls = _useState2[1];
  var CheckProductSelected = function CheckProductSelected(planNumber) {
    return selectedProduct && (planNumber === selectedProduct.planNumber || productsAreMerged && selectedProduct.basePlanNo === planNumber);
  };
  var HandleProductSelection = function HandleProductSelection(_ref3) {
    var productDefinition = _ref3.productDefinition;
    var planNumber = productDefinition.planNumber;
    onPlanSelect({
      productDefinition: productDefinition,
      planQuote: productQuotes[planNumber]
    }, planKey);
  };
  var ActivateProductGrouping = function ActivateProductGrouping(productGrouping) {
    onActiveProductGroupChange(productGrouping);
  };
  var getColspan = function getColspan(productGrouping) {
    if (productGrouping.productsGroups) {
      return productGrouping.productsGroups.reduce(function (acc, productGroup) {
        var visiblePlansForGroup = Object.values(plans).filter(function (plan) {
          var planNumber = plan.planNumber;
          return ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)] === productGroup;
        });
        return acc + visiblePlansForGroup.length;
      }, 0);
    }
    return 1;
  };
  (0, _react.useEffect)(function () {
    var groupControlsState = showProductGroupControls && plans && speciesFilter !== 'all' && ProductGroupingsBySpecies.length > 0;
    if (groupControlsState !== hasProductGroupControls) {
      setHasProductGroupControls(groupControlsState);
    }
  }, [showProductGroupControls, plans, speciesFilter, ProductGroupingsBySpecies, hasProductGroupControls, setHasProductGroupControls]);
  var productCoverItemLabel = (0, _react.useMemo)(function () {
    var productLoadings = (0, _quoteHelpers.ExtractAllLoadings)({
      productQuotes: productQuotes
    });
    return !dataIsUpdating ? title({
      allLoadings: productLoadings
    }) : '';
  }, [productQuotes, dataIsUpdating, title]);
  return /*#__PURE__*/_react["default"].createElement("thead", null, hasProductGroupControls && /*#__PURE__*/_react["default"].createElement("tr", {
    className: "productGroupControlHeaders"
  }, /*#__PURE__*/_react["default"].createElement("th", {
    className: "blank"
  }, "\xA0"), ProductGroupingsBySpecies.map(function (productGrouping, index) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      colSpan: getColspan(productGrouping),
      key: "tableGroupControl".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "button productGroupingButton ".concat(activeProductGroup === productGrouping ? 'secondary' : ''),
      onClick: function onClick() {
        return ActivateProductGrouping(productGrouping);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "labelText"
    }, productGrouping.label)));
  })), /*#__PURE__*/_react["default"].createElement("tr", {
    className: "productNameHeaders"
  }, plans && Object.values(plans).map(function (productDefinition, columnIndex) {
    var planNumber = productDefinition.planNumber;
    var planProductGroup = ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)];
    var isDisabled = hasProductGroupControls && (0, _tableHelpers.ProductGroupFilterExcludesPlan)({
      productGroup: planProductGroup,
      activeProductGroup: activeProductGroup
    });
    var productName = (0, _productHelpers.GetProductName)({
      productDefinition: productDefinition,
      planProductGroup: planProductGroup,
      groupedProductNames: groupedProductNames,
      productsAreMerged: productsAreMerged
    });
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "productTableHeading_".concat(planNumber)
    }, columnIndex === 0 && !mobileMode && /*#__PURE__*/_react["default"].createElement("th", {
      className: "productCoverItemLabel"
    }, productCoverItemLabel), /*#__PURE__*/_react["default"].createElement("th", {
      colSpan: mobileMode ? '100%' : null,
      className: (0, _tableHelpers.GetCellCssClass)({
        planNumber: planNumber,
        planProductGroup: planProductGroup,
        activeProductGroup: activeProductGroup,
        selectedProduct: selectedProduct,
        productsAreMerged: productsAreMerged
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "productNameHeader"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "productNameHeading ".concat(mobileMode ? 'headingLeft' : '')
    }, productName), /*#__PURE__*/_react["default"].createElement(_productPriceInfo.ProductPriceInfo, {
      contentToggleable: contentToggleable,
      productIsSelected: CheckProductSelected(planNumber),
      planNumber: planNumber,
      isDisabled: isDisabled,
      plansVisible: plansVisible,
      onTogglePlanVisibility: onTogglePlanVisibility,
      mobileMode: mobileMode,
      onPlanSelect: function onPlanSelect() {
        return HandleProductSelection({
          productDefinition: productDefinition
        });
      },
      productName: productName
    }), staffMode && /*#__PURE__*/_react["default"].createElement(_staffProductSummary.StaffProductSummary, {
      plan: productDefinition
    }))));
  })));
};
ProductsTableHead.propTypes = {
  contentToggleable: _propTypes["default"].bool,
  plans: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  plansVisible: _propTypes["default"].bool,
  onActiveProductGroupChange: _propTypes["default"].func,
  onTogglePlanVisibility: _propTypes["default"].func,
  onPlanSelect: _propTypes["default"].func,
  validationErrors: _propTypes["default"].any,
  planKey: _propTypes["default"].string
};